import { AxiosError } from 'axios';
import { defaultCallApi, useRefreshApi } from '..';
import { useStickySafeNavigate } from '../../..';
import { useIsMsalAuth } from '../../authentication';
import { ToastStatus, useToastNotifications } from '../../components';

export function useErrorNotificationApi(
  apiUrl?: (path: string) => string,
  errorHandler?: ((res: AxiosError<any, any>) => void) | null,
) {
  const isMsalAuth = useIsMsalAuth();
  const { addToastNotification } = useToastNotifications();
  const navigate = useStickySafeNavigate();

  const errorNotification = () => addToastNotification({
    text: `Failed activity. Try again later.
        If the issue persists please contact
        ${isMsalAuth ? 'Equifinance IT Team' : 'Equifinance'}.`,
    type: ToastStatus.ERROR,
    showCloseIcon: true,
  });

  return useRefreshApi(apiUrl, errorHandler, async (responseCall, apiCall) => defaultCallApi(responseCall, apiCall).catch((error) => {
    if (error?.response?.status === 403) {
      navigate('/403');
    } else {
      errorNotification();
    }
    throw error;
  }));
}
